/* ============================================================
   AP ANIMATIONS - port exact de la maquette
   ============================================================ */
(function() {
'use strict';

/* ?? 1. REVEAL ?? */
function initReveals() {
  var els = document.querySelectorAll('.reveal');
  var clips = document.querySelectorAll('.reveal-clip');

  /* Sur mobile : tout afficher immédiatement, pas d'observers — évite les cascades CSS au scroll */
  if (window.matchMedia('(max-width: 750px)').matches || !('IntersectionObserver' in window)) {
    els.forEach(function(el){ el.classList.add('in'); });
    clips.forEach(function(el){ el.classList.add('in'); });
    return;
  }

  var revealIO = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('in'); revealIO.unobserve(e.target); }
    });
  }, { threshold: 0.05 });

  var clipIO = new IntersectionObserver(function(entries) {
    entries.forEach(function(e) {
      if (e.isIntersecting) { e.target.classList.add('in'); clipIO.unobserve(e.target); }
    });
  }, { threshold: 0.05 });

  els.forEach(function(el){ revealIO.observe(el); });
  clips.forEach(function(el){ clipIO.observe(el); });

  setTimeout(function(){
    document.querySelectorAll('.reveal:not(.in)').forEach(function(el){ el.classList.add('in'); });
    document.querySelectorAll('.reveal-clip:not(.in)').forEach(function(el){ el.classList.add('in'); });
  }, 3000);
}

/* ?? 2. FLACON 3D (port exact de components.jsx) ?? */
function grayPanel(angleDeg, opt) {
  var lightAt = opt.lightAt || 322;
  var a = ((angleDeg % 360) + 360) % 360;
  var d = Math.cos(((a - lightAt) * Math.PI) / 180);
  var dd = Math.abs((a - lightAt + 360) % 360);
  if (dd > 180) dd = 360 - dd;
  var L = opt.baseL + opt.amp * d;
  if (dd < opt.specW) L += opt.specL * (1 - dd / opt.specW);
  L = Math.max(0.02, Math.min(0.99, L));
  var top = Math.round(L * 100);
  var bot = Math.round(Math.max(0.02, L - opt.vGrad) * 100);
  return 'linear-gradient(178deg,hsl(0 0% '+top+'%) 0%,hsl(0 0% '+top+'%) 52%,hsl(0 0% '+bot+'%) 100%)';
}

function createFlacon(container, opts) {
  var size = (opts && opts.size) || 1;
  var label = (opts && opts.label) || 'AP';
  var sub = (opts && opts.sub) || "L'ATELIER \xB7 PARFUM";
  var autoSpin = opts && opts.autoSpin !== undefined ? opts.autoSpin : true;
  var draggable = opts && opts.draggable !== undefined ? opts.draggable : true;

  var st = { angle: -18, vel: 0, dragging: false, lastX: 0 };

  container.className = 'stage3d';
  container.style.width = '100%';
  container.style.height = '100%';
  container.style.cursor = draggable ? 'grab' : 'default';

  var flaconEl = document.createElement('div');
  flaconEl.className = 'flacon';
  flaconEl.style.cssText = 'width:0;height:0;transform-style:preserve-3d;will-change:transform;transform:rotateX(-7deg) rotateY(-18deg)';
  flaconEl.style.scale = String(size);
  container.appendChild(flaconEl);

  var N=30, rBody=80, hBody=208, rCollar=40, hCollar=12, rCap=44, hCap=58;
  var total=hBody+hCollar+hCap;
  var yCap=-total/2+hCap/2, yCollar=-total/2+hCap+hCollar/2, yBody=-total/2+hCap+hCollar+hBody/2;

  function buildCyl(r,h,cy,n,opt){
    var w=Math.ceil((2*Math.PI*r)/n)+2;
    for(var i=0;i<n;i++){
      var ang=i*(360/n);
      var p=document.createElement('div');
      p.style.cssText='position:absolute;left:50%;top:50%;width:'+w+'px;height:'+h+'px;margin-left:'+(-w/2)+'px;margin-top:'+(-h/2)+'px;background:'+grayPanel(ang,opt)+';transform:translateY('+cy+'px) rotateY('+ang+'deg) translateZ('+r+'px);backface-visibility:hidden;';
      flaconEl.appendChild(p);
    }
  }
  function disc(r,cy,bg){
    var d=document.createElement('div');
    d.style.cssText='position:absolute;left:50%;top:50%;width:'+(2*r)+'px;height:'+(2*r)+'px;margin-left:'+(-r)+'px;margin-top:'+(-r)+'px;border-radius:50%;background:'+bg+';transform:translateY('+cy+'px) rotateX(90deg);backface-visibility:hidden;';
    flaconEl.appendChild(d);
  }

  buildCyl(rBody,hBody,yBody,N,{baseL:0.82,amp:0.12,specL:0.16,specW:24,vGrad:0.24});
  disc(rBody,yBody-hBody/2,'radial-gradient(circle at 38% 32%,#f4f4f2,#d2d2d0 68%,#bdbdbb)');
  buildCyl(rCollar,hCollar,yCollar,N,{baseL:0.16,amp:0.09,specL:0.3,specW:22,vGrad:0.05});
  buildCyl(rCap,hCap,yCap,N,{baseL:0.08,amp:0.06,specL:0.42,specW:20,vGrad:-0.04});
  disc(rCap,yCap-hCap/2,'radial-gradient(circle at 40% 34%,#2e2e2e,#0a0a0a 72%)');

  var lbl=document.createElement('div');
  lbl.style.cssText='position:absolute;left:50%;top:50%;width:110px;height:122px;margin-left:-55px;margin-top:-61px;transform:translateY('+(yBody+4)+'px) translateZ('+(rBody+0.5)+'px);backface-visibility:hidden;display:flex;flex-direction:column;align-items:center;justify-content:center;gap:7px;';
  lbl.innerHTML='<div style="font-family:var(--serif);font-size:42px;letter-spacing:0.05em;color:rgba(20,20,20,0.4);line-height:1;">'+label+'</div><div style="width:26px;height:1px;background:rgba(20,20,20,0.32);"></div><div style="font-family:var(--sans);font-size:7px;letter-spacing:0.28em;color:rgba(20,20,20,0.44);">'+sub+'</div>';
  flaconEl.appendChild(lbl);

  var caustic=document.createElement('div');
  caustic.className='caustic';
  caustic.style.cssText='width:'+(2*rBody*1.45*size)+'px;height:'+(44*size)+'px;position:absolute;bottom:calc(50% - '+((total/2)*size+22)+'px);';
  container.appendChild(caustic);

  var prev=performance.now(), raf=0;
  function tick(t){
    var dt=Math.min(42,t-prev); prev=t;
    if(!st.dragging){ if(autoSpin) st.angle+=0.015*dt; st.angle+=st.vel; st.vel*=0.93; }
    flaconEl.style.transform='rotateX(-7deg) rotateY('+st.angle+'deg)';
    raf=requestAnimationFrame(tick);
  }
  raf=requestAnimationFrame(tick);

  if(draggable){
    container.addEventListener('pointerdown',function(e){
      st.dragging=true; st.vel=0; st.lastX=e.clientX;
      try{container.setPointerCapture(e.pointerId);}catch(x){}
      container.style.cursor='grabbing';
    });
    container.addEventListener('pointermove',function(e){
      if(!st.dragging)return;
      var dx=e.clientX-st.lastX; st.lastX=e.clientX;
      st.angle+=dx*0.5; st.vel=dx*0.5;
    });
    function up(){ st.dragging=false; container.style.cursor='grab'; }
    container.addEventListener('pointerup',up);
    container.addEventListener('pointerleave',up);
  }
}

function initFlacons(){
  document.querySelectorAll('.ap-flacon').forEach(function(el){
    createFlacon(el,{
      size:parseFloat(el.dataset.size)||1,
      label:el.dataset.label||'AP',
      autoSpin:true, draggable:true
    });
  });
}

/* ?? 3. PAGE TRANSITION ?? */
var transEl=document.getElementById('ap-transition');
function doTransition(href){
  if(!transEl || !transEl.animate){ window.location=href; return; }
  transEl.style.visibility='visible';
  transEl.style.pointerEvents='auto';
  transEl.animate(
    [{transform:'translateY(101%)'},{transform:'translateY(0%)'}],
    {duration:520,easing:'cubic-bezier(0.76,0,0.24,1)',fill:'forwards'}
  );
  setTimeout(function(){ window.location=href; }, 540);
}
function initTransitions(){
  // Transitions désactivées sur mobile — le délai 540ms est perçu comme un freeze
  if (window.matchMedia('(max-width: 750px)').matches) return;
  document.querySelectorAll('a[href]').forEach(function(a){
    var href=a.getAttribute('href');
    if(!href||href[0]==='#'||href.indexOf('http')===0||href.indexOf('mailto')===0||href.indexOf('tel')===0) return;
    a.addEventListener('click',function(e){
      e.preventDefault(); doTransition(a.href);
    });
  });
}

/* ?? 4. NAV SCROLL ?? */
function initNav(){
  var nav=document.getElementById('ap-nav');
  if(!nav)return;
  window.addEventListener('scroll',function(){ nav.classList.toggle('is-scrolled',window.scrollY>24); },{passive:true});
}

/* ?? INIT ?? */
function init(){
  initNav();
  initReveals();
  initFlacons();
  initTransitions();
}
if(document.readyState==='loading'){ document.addEventListener('DOMContentLoaded',init); } else { init(); }

})();